import React, { forwardRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { InputBox, Input } from '../../../../../components/atoms';

const StyledInput = styled(Input)`
  border-radius: 0;
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;

  &::-ms-expand {
    display: none;
  }
`;

const StyledInputBox = styled(InputBox)`
  border: none;
  outline: none;
  width: auto;
  flex-grow: 1;
  height: 26px;
  padding: 4px 0;
  border-radius: 8px;

  &:hover {
    background-color: transparent;
    box-shadow: none;
  }
  &:focus-within {
    background-color: transparent;
    box-shadow: none;
    border: none;
  }
`;

const ShareModalSelectTextField = forwardRef(
  (
    {
      name,
      onChange,
      autoComplete = null,
      max = null,
      min = null,
      placeholder = null,
      type = 'text',
      onBlur = null,
      onFocus = null,
      onKeyDown = null
    },
    ref
  ) => (
    <StyledInputBox htmlFor={name}>
      <StyledInput
        autoComplete={autoComplete}
        id={name}
        max={max}
        min={min}
        name={name}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        ref={ref}
        type={type}
      />
    </StyledInputBox>
  )
);

ShareModalSelectTextField.propTypes = {
  autoComplete: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string
};

export { ShareModalSelectTextField };
